import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { useContext } from 'sb-hooks'
import { intlMessageShape } from 'sb-react-intl'

import Text from 'components/_new/typography/Text/Text'

import { RadioGroupContext } from '../RadioGroup/RadioGroup'

import s from './RadioButton.scss'


const RadioButton = (props) => {
  const { children, className, label, value, dataTestId } = props

  const { activeValue, name, onChange } = useContext(RadioGroupContext)

  const rootClassName = cx(s.label, className)

  const nodeProps = {
    className: s.input,
    type: 'radio',
    value,
    name,
    checked: activeValue === value,
    onChange,
  }

  return (
    <label className={rootClassName} data-testid={dataTestId}>
      <input {...nodeProps} />
      <span className={s.radio} />
      {
        Boolean(label) && (
          <Text message={label} html />
        )
      }
      {children}
    </label>
  )
}

RadioButton.propTypes = {
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape(intlMessageShape),
  ]),
  dataTestId: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
}


export default RadioButton
